import { logError } from '../logger';

export interface AgeRange {
  min: number;
  max: number;
  age?: number;
}

export type StringOrStringArray = string | string[];

const DEFAULT_PASSENGER: AgeRange = { min: 26, max: 57 };

const DEFAULT_PASSENGER_AGES: AgeRange[] = [DEFAULT_PASSENGER];

/**
 * Receives an array containing strings with 3 columns:
 * 1 - min range
 * 2 - max range
 * 3 - actual age, when available
 */
function convertToPassengersWithRanges(passengers: StringOrStringArray): AgeRange[] {
  if (!passengers) {
    return DEFAULT_PASSENGER_AGES;
  }

  const passengersList = Array.isArray(passengers) ? passengers : [passengers];

  return passengersList.map((data) => {
    const [minString, maxString, ageString] = data.split(':');
    const min = parseInt(minString, 10) || 0;
    const max = parseInt(maxString, 10) || 0;
    const age = ageString ? parseInt(ageString, 10) || 0 : undefined;

    if (age === undefined) {
      return {
        min,
        max,
      };
    }

    return {
      min,
      max,
      age,
    };
  });
}

/**
 * Transforms the number of passengers into an object containing the range of min and max ages.
 * It can also include ages, but only when available.
 */
function passengersBuilder(passengerAges?: StringOrStringArray): AgeRange[] {
  if (!passengerAges || !passengerAges[0]) {
    return DEFAULT_PASSENGER_AGES;
  }

  try {
    return convertToPassengersWithRanges(passengerAges);
  } catch (error) {
    const message = (error && (error as Error)?.message) || 'Unknown';

    logError(`Parsing passenger ages failed with error: ${message}`);

    return DEFAULT_PASSENGER_AGES;
  }
}

export default passengersBuilder;
